module.exports = __webpack_public_path__ + "static/img/woman.01b90eb4.png";